export enum TaxabilityType{
    Exempt ="Exempt",
    NillRated="Nill Rated",
    NonGst='Non Gst',
    Taxable='Taxable'
}
